<template>
  <div id="app">
    <loading-page v-if="isLoading"></loading-page>
    <router-view v-if="!isLoading" />
  </div>
</template>

<script>
import LoadingPage from '@/pages/LoadingPage.vue';
import { AUTH_TOKEN } from '@/store/actions/auth';
import { STORAGE } from '@/constants/storage.constants';

export default {
  name: 'app',
  components: {
    LoadingPage,
  },
  data: () => {
    return {
      entryPage: null,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.auth.loading;
    },
  },
  watch: {
    $route() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  beforeMount() {
    this.entryPage = localStorage.getItem(STORAGE.PAGE_URL);
    localStorage.removeItem(STORAGE.PAGE_URL);
  },
  mounted() {
    setTimeout(() => {
      this.$store
        .dispatch(AUTH_TOKEN)
        .then(() => this.$router.push(this.entryPage ? this.entryPage : '/'));
    }, 1000);
  },
};
</script>

<style lang="scss">
@import 'styles/_global.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}
</style>
